import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-calendar/dist/Calendar.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

// navigator.serviceWorker.register('/firebase-messaging-sw.js')
//   .then((registration) => {
//     console.log('Service Worker registered:', registration);
//   })
//   .catch((error) => {
//     console.error('Service Worker registration failed:', error);
//   });
  
root.render(
 
    <App />

);

reportWebVitals();
